import React from 'react';

const EmptyRow = ({ hasActiveFilters }) => {
  return (
    <tr>
      <td colSpan={7} className="py-8 text-center text-sm text-gray-500 dark:text-gray-400">
        {hasActiveFilters 
          ? 'No budget items match the current filters. Try adjusting your filters to see more results.' 
          : 'No budget items found.'}
      </td>
    </tr>
  );
};

export default EmptyRow;